import { useStoredPicksheet } from '~/domains/contest/domains/gamecenter/domains/common/hooks/useStoredPicksheet';

import type { PropPickProps } from '../../../types/propPickProps.type';

function useStoredPicks() {
  return useStoredPicksheet<PropPickProps[]>({ contestId: 'quickPicks' });
}

export default useStoredPicks;
